import axios from 'axios'
import { RolOutPutDTO } from './rolDTO'
import { getJWT } from 'src/helper/localStore/getJWT'
import { IsAuthorized } from 'src/authentication/IsAuthorized'
class RoleServices {
  async getById(id: number): Promise<RolOutPutDTO | undefined> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_AUTH}/role/${id}`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }
  async getByAll(): Promise<RolOutPutDTO[] | undefined> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_AUTH}/role`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getRolesByApplicationAndClient(
    id_application: number,
    id_client: number
  ): Promise<RolOutPutDTO[] | null> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_AUTH}/role/app/${id_application}/cli/${id_client}`,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      if (res.status === 404) {
        return null
      }
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }
}

export const roleServices = new RoleServices()
